module.exports = __webpack_public_path__ + "static/media/auth-check-invalid.97cfbde7c877916be3837b22ec88f8d5.svg";